import { render, staticRenderFns } from "./ProfileCompletenessAlert.vue?vue&type=template&id=86e7b344&scoped=true&"
import script from "./ProfileCompletenessAlert.vue?vue&type=script&lang=js&"
export * from "./ProfileCompletenessAlert.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCompletenessAlert.vue?vue&type=style&index=0&id=86e7b344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e7b344",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow})
